<main id="users">
  <div class="card">
    <div class="card-header">
      <div class="row card-title">
        <div class="col-12">
          <h5 class="m-0 p-0">
            <span class="float-start" i18n="@@CustomerOverviewHeader"><app-svg source="icons/feather/users" height="18" class="me-2"></app-svg>Benutzerübersicht ({{ tableFunctions.total$ | async }})</span>
          </h5>
        </div>
      </div>
    </div>

    <div class="card-body">
      <router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>
    </div>

    <div class="card-footer" [ngStyle]="{'display': componentSettings.footerVisible == true ? 'block' : 'none' }">
      <div class="d-flex">
        <div class="flex-fill d-none d-md-inline">
          <div class="d-flex">
            <div class="flex p-2" i18n="@@ElementsPerPage">Elemente pro Seite</div>
            <div class="flex">
              <select id="pageSize" name="pageSize" [(ngModel)]="tableFunctions.pageSize"
                      class="form-control form-select custom-select" aria-label=""
                      (change)="tableFunctions.onPageSizeChange(activeComponentClassName)">
                <option [ngValue]="10">10</option>
                <option [ngValue]="25">25</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
                <option [ngValue]="250">250</option>
              </select>
            </div>
          </div>
        </div>

        <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
          <ngb-pagination #pagination [collectionSize]="(tableFunctions.total$ | async)!"
                          [(page)]="tableFunctions.page" [pageSize]="tableFunctions.pageSize"
                          [maxSize]="tableFunctions.page == 3 ? 3 : 2" [boundaryLinks]="true" [rotate]="true">
          </ngb-pagination>
        </div>

        <div class="flex-fill justify-content-end d-none d-md-inline">
          <div class="d-flex float-end">
            <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
            <div class="flex">
              <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select" aria-label="">
                <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index"
                        [ngValue]="i + 1">
                  {{ i + 1 }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
